<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title + ' > ' + tipoArquivo" @hidden="closeModal" @close="closeModal">
    <b-card bg-variant="light">
      <b-form @submit.prevent="save">
        <b-form-row>
          <b-col cols='12'>
            <LgFinderPagePessoa label="Almoxarife:" v-model="form.almoxarife" :prefix="title + ' > '" id="finderPagePessoa"/>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col cols='12' class="text-left">
            <lg-form-select class="col-sm-12" style="z-index: 21" v-model="form.tarefa" :loadFunction="listTipoTarefaPedido"
                            labelFormGroupBind="Tipo Tarefa:" label="descricao" description="" filterList="true" lg="3" sm="3" />
          </b-col>
        </b-form-row>
      </b-form>

      <div class="d-flex justify-content-center">
        <div class="text-right">
          <b-button id="salvar" type="submit" variant="success" @click="gerarRelatorio" size="sm"  pill style="height: 20px" :title="'Salvar'">
            <b-tooltip target="salvar" title="Gerar Relatório"></b-tooltip>
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
          </b-button>

          <b-button id="cancelar" class="ml-2" @click="close" variant="danger" pill style="height: 20px" size="sm">
            <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
          </b-button>
        </div>
      </div>
    </b-card>
  </b-modal>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";

export default {
    components: {
      LgFormSelect,
      LgFinderPagePessoa
    },
    props: {
      tipoArquivo: {
        type: String,
        default: null,
      },
      prefix: {
        type: String,
        default: "Pedido",
      },
      title: {
        type: String,
        default: " > Relatório de Pedidos e Tarefas",
      },
      filtros:{}
    },
    beforeMount() {
      this.$serviceTipoTarefaPedido = new ResourceService(`/api/tipotarefapedido`)
    },

    data() {
      return {
        params: {},
        showModal: true,
        busy: false,
        form: {
          almoxarife: {},
          tarefa: {},
        },
      }
    },

    methods: {
      closeModal() {
        this.showModal = false
        this.$emit("close")
      },
      async listTipoTarefaPedido({ filter, page = 1 }) {
        return this.$serviceTipoTarefaPedido.findAll({ filter, page, limit: 5 })
      },
      async gerarRelatorio() {

        this.param = {};

        if (this.form.almoxarife) {
          this.param.almoxarifeId = this.form.almoxarife.id;
        }
        if (this.form.tarefa) {
          this.param.tarefaId = this.form.tarefa.id;
        }
        if (this.filtros.almoxarifado) {
          this.param.almoxarifadoId = this.filtros.almoxarifado.id;
        }
        if (this.filtros.departamento) {
          this.param.departamentoId = this.filtros.departamento.id;
        }
        if (this.filtros.produto) {
          this.param.produtoId = this.filtros.produto.id;
        }
        if (this.filtros.status) {
          this.param.statusId = this.filtros.status.id;
        }

        this.param.descricaoExata = this.filtros.descricaoExata;

        if (this.filtros.pedidoId != null) {
          this.param.pedidoId = this.filtros.pedidoId;
        }

        if (this.filtros.justificativa !== "") {
          this.param.justificativa = this.filtros.justificativa;
        }

        if (this.filtros.dataDe != "" && this.filtros.dataAte != "") {
          this.param.dataInicio = this.converterData(this.filtros.dataDe);
          this.param.dataFim = this.converterData(this.filtros.dataAte);
        }


        this.busy = true
        try {
          const resource = new ResourceService('/api/relatorio/gerar-relatorio-pedidos-e-tarefas');
          const { data } = await resource.getWithParams(this.tipoArquivo, this.param);
          DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
        }catch (error) {
          this.$notify({
            type: "danger",
            message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
            timeout: 3000,
          });
        } finally {
          this.busy = false;
          this.close();
        }
      },
      close() {
        this.$emit("close")
      },
      converterData(date) {
        const [ano, mes, dia] = date.split("-");
        return `${dia}/${mes}/${ano}`;
      },
    },
  }
</script>

<style scoped>

</style>
